import './auth-light.css';
import './breadcrumb-light.css';
import './button-light.css';
import './calendar-light.css';
import './component-light.css';
import './datatable-light.css';
import './dropdown-light.css';
import './dropzone-light.css';
import './error-light.css';
import './folders-light.css';
import './impagination-light.css';
import './input-light.css';
import './notification-light.css';
import './select2-light.css';
import './tab-light.css';
